import clsx from 'clsx';
import { Fieldset as _Fieldset } from '@base-ui/react/fieldset';
import { forwardRef } from '@wordpress/element';
import fieldStyles from '../../../utils/css/field.module.css';
import { VisuallyHidden } from '../../../visually-hidden';
import styles from './style.module.css';
import type { FieldsetLegendProps } from './types';

export const FieldsetLegend = forwardRef< HTMLDivElement, FieldsetLegendProps >(
	function UnforwardedFieldsetLegend(
		{ className, hideFromVision, ...restProps },
		ref
	) {
		const legend = (
			<_Fieldset.Legend
				ref={ ref }
				className={ clsx(
					styles.legend,
					hideFromVision && styles[ 'is-hidden' ],
					fieldStyles.label,
					className
				) }
				{ ...restProps }
			/>
		);

		// VisuallyHidden is the host so that _Fieldset.Legend's semantic
		// element is preserved. See VisuallyHidden docs for details.
		if ( hideFromVision ) {
			return <VisuallyHidden render={ legend } />;
		}

		return legend;
	}
);
